import { createSaga } from './saga-helpers';

import * as Api from '../api/recursion-rules-api';

const watchGetRecursionRules = createSaga({
    type: 'RECURSION_RULES_FETCH',
    fn: Api.fetchRecursionRules,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateRecursionRule = createSaga({
    type: 'RECURSION_RULE_CREATE',
    fn: Api.createRecursionRule,
    args: action => [action.payload.rule],
    successPayload: ({ id: ruleId }, action) => ({
        ruleId,
        fragment: action.payload.rule
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.rule
    })
});

const watchGetRecursionRule = createSaga({
    type: 'RECURSION_RULE_FETCH',
    fn: Api.fetchRecursionRule,
    args: action => [action.payload.ruleId],
    successPayload: rule => ({ rule })
});

const watchUpdateRecursionRule = createSaga({
    type: 'RECURSION_RULE_UPDATE',
    fn: Api.updateRecursionRule,
    args: action => [action.payload.ruleId, action.payload.ruleProps],
    successPayload: rule => ({ rule })
});

const watchRemoveRecursionRule = createSaga({
    type: 'RECURSION_RULE_REMOVE',
    fn: Api.removeRecursionRule,
    args: action => [action.payload.ruleId]
});

const sagas = [watchGetRecursionRules, watchCreateRecursionRule, watchGetRecursionRule, watchUpdateRecursionRule, watchRemoveRecursionRule];

export default sagas;
